/* Yeti booking page, v74 (7 Oct 2026): slot-day notice at the top of the page.
   Upcoming slot days (event / busy days) only run half-day demo slots, so say so before
   anyone starts. Consecutive days with the same label make one line; the first three
   lines show, the rest sit behind "+ N more dates". Not shown on ?hold= links.
   Loads after yb-1/yb-2 and before yb-3, and hooks loadDays() so it draws as soon as
   the day rules arrive. Prices come from S.slotPrice (set by the Hub's /days). */
function slotGroups(){
  var g=[];
  upcomingSlotDays().forEach(function(d){
    var lb=(rule(d)&&rule(d).label)||'',last=g[g.length-1];
    if(last&&last.label===lb&&iso(addD(dParse(last.end),1))===d)last.end=d;
    else g.push({start:d,end:d,label:lb});
  });
  return g;
}
function slotRangeTxt(a,b){
  var A=dParse(a),B=dParse(b),wd=function(x){return x.toLocaleDateString('en-NZ',{weekday:'short'});},
      mo=function(x){return x.toLocaleDateString('en-NZ',{month:'short'});};
  if(a===b)return wd(A)+' '+A.getDate()+' '+mo(A);
  return wd(A)+' '+A.getDate()+(A.getMonth()===B.getMonth()?'':' '+mo(A))+' – '+wd(B)+' '+B.getDate()+' '+mo(B);
}
function slotNotice(){
  var box=document.getElementById('yb-slotnotice');if(!box)return;
  if(new URLSearchParams(location.search).get('hold')){box.innerHTML='';return;}
  var g=slotGroups();
  if(!g.length){box.innerHTML='';return;}
  var one=g.length===1,why=one?(g[0].label?' because of '+esc(g[0].label):g[0].start===g[0].end?' because it\'s a busy day':' because they\'re busy days'):'';
  var line=function(x){return '<li><b>'+slotRangeTxt(x.start,x.end)+'</b><span> · '+(x.label?esc(x.label):'busy day')+'</span></li>';};
  var more=g.length-3,moreTxt='+ '+more+' more '+(more===1?'date':'dates');
  box.innerHTML='<div class="yb-slotnote" role="note">'+
    '<h2>Heads up: some days are short demos days</h2>'+
    '<p>On these days our bikes go out for a morning or an afternoon, not the full day'+why+'. Slots are '+money(S.slotPrice.analog)+' a bike / '+money(S.slotPrice.ebike)+' an e-bike. No full-day demos or hires are available on these days, and a hire can\'t run across them.</p>'+
    '<ul>'+g.slice(0,3).map(line).join('')+'</ul>'+
    (more>0?'<ul class="yb-sn-more" hidden>'+g.slice(3).map(line).join('')+'</ul><button type="button" class="yb-sn-toggle">'+moreTxt+'</button>':'')+
    '<div><button type="button" class="yb-btn yb-sn-book">Book a half-day</button></div></div>';
  var t=box.querySelector('.yb-sn-toggle');
  if(t)t.onclick=function(){var m=box.querySelector('.yb-sn-more'),open=m.hidden;m.hidden=!open;t.textContent=open?'Show fewer dates':moreTxt;};
  box.querySelector('.yb-sn-book').onclick=function(){S.flow='slot';S.cart=[];S.slotDay=upcomingSlotDays()[0];S.slot=null;go(1);};
}
/* The Hub's /days can send day keys as "Fri Oct 23" instead of "2026-10-23" (and the e-bike
   slot price as slot_ebike_price_cents). Put them back into ISO dates so the calendar,
   the slot step and this notice all line up. Year = the one that puts the day within
   the next ~4 months. Harmless once the Hub sends ISO dates. */
function normaliseDays(){
  var MON={Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11},t0=addD(today(),-1),out={};
  Object.keys(S.days).forEach(function(k){
    var v=S.days[k],key=k;
    if(!/^\d{4}-\d{2}-\d{2}$/.test(k)){
      var m=/([A-Z][a-z]{2})\s+(\d{1,2})(?:\s+(\d{4}))?/.exec(k);
      if(m&&MON[m[1]]!=null){var y=m[3]?+m[3]:today().getFullYear(),d=new Date(y,MON[m[1]],+m[2]);if(!m[3]&&d<t0)d=new Date(y+1,MON[m[1]],+m[2]);key=iso(d);}
    }
    v.day=key;out[key]=v;
  });
  S.days=out;
}
(function(){var ld=loadDays;loadDays=function(){
  var pre=S.lmPending?lmCheck(S.lmPending).catch(function(){}):Promise.resolve();S.lmPending=null;
  return pre.then(function(){return api('/days?from='+iso(today())+'&to='+iso(addD(today(),120))+lmQ());}).then(function(r){
    if(typeof r.lead_days==='number')LEAD_DAYS=r.lead_days;
    (r.days||[]).forEach(function(x){S.days[x.day]=x;});
    if(r.slot_price_cents)S.slotPrice.analog=r.slot_price_cents;
    var e=r.slot_ebike_price_cents||r.price_ebike_cents;if(e)S.slotPrice.ebike=e;
    normaliseDays();slotNotice();
  }).catch(function(){return ld().then(function(){normaliseDays();slotNotice();});});
};})();

/* ── v78 (9 Oct 2026): last-minute codes ──
   Kashi gives the standing last-minute code (set in the Hub) to people he's talked to; it lets
   them book from today instead of the day after tomorrow. The code is never printed on the page. "Have a last-minute code?" sits quietly under the
   dates (and the half-day slot picker). A good code re-reads /days with &code= (lead_days 0),
   and goes on the hold as "code". The server checks everything; ?code=<word> in the URL
   applies it on load. Also: api() now shows the server's message (not "too_soon"). */
S.lmCode=null;S.lmLabel='';S.lmPending=new URLSearchParams(location.search).get('code')||null;
function lmNorm(c){return String(c||'').trim();} // the server ignores case, spaces and punctuation
function lmQ(){return S.lmCode?'&code='+encodeURIComponent(S.lmCode):'';}
api=function(path,opts){
  if(S.lmCode&&/^\/hold(\?|$)/.test(path)&&opts&&opts.body){try{var b=JSON.parse(opts.body);b.code=S.lmCode;opts=Object.assign({},opts,{body:JSON.stringify(b)});}catch(e){}}
  return fetch(BASE+path,opts).then(function(r){return r.json().catch(function(){return {};}).then(function(j){
    if(!r.ok){var m=j.message||j.why||(j.error&&!/^[a-z_]+$/.test(j.error)?j.error:'')||'Something went wrong — please try again, or call us.';var e=new Error(m);e.code=j.error;e.status=r.status;throw e;}
    return j;});});
};
function lmCheck(raw){
  var c=lmNorm(raw);if(!c)return Promise.reject(new Error('Type the code we gave you.'));
  return api('/code?code='+encodeURIComponent(c)).then(function(r){
    if(!r||!r.ok)throw new Error((r&&r.why)||'That code isn\'t valid.');
    S.lmCode=c;S.lmLabel=r.label||'';
    if(r.earliest){var d=Math.round((dParse(r.earliest)-today())/864e5);LEAD_DAYS=Math.max(0,d);}else LEAD_DAYS=0;
    return r;
  },function(e){if(e.status===404||!e.status)throw new Error('We couldn\'t check that code just now. Message us and we\'ll sort it.');throw e;});
}
function lmHtml(){
  if(S.lmCode)return '<div class="yb-lm on"><span>✓ Code accepted. You can book from '+(LEAD_DAYS===0?'today':fmt(iso(firstBookable())))+'.</span> <button type="button" class="yb-lm-x">Remove</button></div>';
  return '<div class="yb-lm"><button type="button" class="yb-lm-toggle">Have a last-minute code?</button>'+
    '<div class="yb-lm-box" hidden><input class="yb-fi" id="yb-lm-in" autocomplete="off" autocapitalize="characters" placeholder="Your code" maxlength="40"><button type="button" class="yb-btn" id="yb-lm-go">Apply</button></div>'+
    '<div class="yb-lm-msg" id="yb-lm-msg" role="status"></div></div>';
}
function lmMount(){
  if(!view||view.querySelector('.yb-lm'))return;
  var w=document.createElement('div');w.innerHTML=lmHtml();var el=w.firstChild;
  var soon=view.querySelector('.yb-soon');
  if(soon){if(S.lmCode)soon.style.display='none';soon.parentNode.insertBefore(el,soon.nextSibling);}
  else{var rows=view.querySelectorAll('.yb-row'),last=rows[rows.length-1];if(last)last.parentNode.insertBefore(el,last);else view.appendChild(el);}
  var reload=function(){S.days={};return loadDays().then(function(){if(S.start&&S.start<iso(firstBookable())){S.start=S.end=null;}render();});};
  var x=el.querySelector('.yb-lm-x');
  if(x){x.onclick=function(){S.lmCode=null;S.lmLabel='';LEAD_DAYS=2;reload();};return;}
  var t=el.querySelector('.yb-lm-toggle'),box=el.querySelector('.yb-lm-box'),inp=el.querySelector('#yb-lm-in'),go=el.querySelector('#yb-lm-go'),msg=el.querySelector('#yb-lm-msg');
  t.onclick=function(){box.hidden=!box.hidden;if(!box.hidden)inp.focus();};
  var apply=function(){msg.textContent='';go.disabled=true;go.textContent='Checking…';
    lmCheck(inp.value).then(reload).catch(function(e){go.disabled=false;go.textContent='Apply';msg.textContent=e.message;});};
  go.onclick=apply;inp.onkeydown=function(e){if(e.key==='Enter'){e.preventDefault();apply();}};
}
// Show it on the dates step and the half-day slot picker (render() draws every step).
(function(){var rn=render;render=function(){var r=rn.apply(this,arguments);
  if(view&&(view.querySelector('.yb-soon')||(S.flow==='slot'&&S.step===1)))lmMount();return r;};})();
